import { Controller } from "stimulus"
import {DataTable} from "simple-datatables"

export default class extends Controller {


  initialize() {
    this.dataTable = new DataTable("#matchesTable", {
      perPage: 15,
      perPageSelect: false,
      labels: {
        aria: {
          sortAscending: "activate to sort column ascending",
          sortDescending: "activate to sort column descending"
        },
        pagination: {
          previous: 'Previous',
          next: 'Next',
          navigateTo: 'Go to page',
          page: 'Page',
          pages: 'Pages'
        },
        noRows: "No matches found",
        info: "Showing {start} to {end} of {rows} matches"
      }
    });
    this.ourSearchBar = document.getElementById('matchesSearchBar');
    this.simpleDatatableSearch = document.getElementsByClassName('dataTable-input')[0];
    this.setupDataTableSearch();
    this.addSortButtonLabels();
    this.addPaginationLabels();
  }

  addSortButtonLabels() {
    //for screenreaders to announce the sort column
    let sortLinks = document.querySelectorAll('.dataTable-sorter');
    sortLinks.forEach((link, index) => {
      link.setAttribute('aria-label', `Sort column ${index + 1}`);
    });
  }

  addPaginationLabels() {
    //for screenreaders to announce the page number in the table
    let paginationLinks = document.querySelectorAll('.dataTable-pagination a');
    paginationLinks.forEach((link, index) => {
      link.setAttribute('aria-label', `Go to page ${index + 1}`);
    });
  }

  setupDataTableSearch(){
    this.ourSearchBar.addEventListener('keyup', (e) => {
      this.simpleDatatableSearch.value = this.ourSearchBar.value;
      this.simpleDatatableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
  }

}
